import React, {useState} from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import UsersFilters from "./usersFilters";
import UsersBody from "./usersBody";
import LoadingIndicator from "../../../common/loadingIndicator";

/**
 * Users Component
 * @returns {JSX.Element}
 * @constructor
 */
const Users = () => {
    const [tableData, setTableData] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});
    const [filters, setFilters] = useState({
        isLoading: false,
        isSubmitted: false,
    });

    return (
        <>
            <Breadcrumb title="Users" parent="Admin"/>
            <UsersFilters
                filters={filters}
                setTableData={setTableData}
                setFilters={setFilters}
            />
            <UsersBody
                filters={filters}
                setFilters={setFilters}
                tableData={tableData}
                setTableData={setTableData}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
            />
            <LoadingIndicator isLoading={filters.isLoading}/>
        </>
    );
}

export default Users;
